import type { Contract } from '../api/generated/types.gen';
import { tenths, toTenths } from '../format';
import { sideName } from '../market';
import { bandIssue, buyBand, buyLimit } from './buyBand';
import { gridPrices } from '../market';
import type { Limits, Position } from '../api/trading';
import { num } from '../format';
import type { Side } from './Ticket';

/** The phone's side buttons. With One-click on (plan 040) a tap buys at once; otherwise it opens the order sheet. */
export function PhoneBar({ contract, onOpen, buys, limits, held, onSell }: { contract: Contract | null; onOpen: (s: Side, shown?: number | null) => void; buys: boolean; limits?: Limits | null; held?: Position | null; onSell?: (p: Position) => void }) {
  // Plan 074: holding what's on screen, the bar is one tap out, at the bid.
  if (held) {
    const bid = toTenths(held.side === 'yes' ? contract?.yes_bid : contract?.no_bid);
    return <div className="phone-bar buys" data-testid="phone-bar">
      <button className="sell" data-testid="phone-sell" onClick={() => onSell?.(held)}>Sell {num(held.quantity)} {sideName(held.side, held.ticker)} {tenths(bid)}</button>
    </div>;
  }
  const verb = buys ? 'Buy ' : '';
  const band = buyBand(limits), grid = gridPrices(contract);
  return <div className={`phone-bar${buys ? ' buys' : ''}`} data-testid="phone-bar">
    {(['yes', 'no'] as const).map(s => {
      const ask = toTenths(s === 'yes' ? contract?.yes_ask : contract?.no_ask);
      // Plan 046: a side priced outside your buy range can't be tapped.
      const outside = bandIssue(band, ask, ask);
      // Plan 072: the button's price is the order's limit.
      const limit = buyLimit(ask, limits, grid);
      return <button key={s} className={s} disabled={!contract || !!outside} title={outside ?? undefined} onClick={() => onOpen(s, limit)}>
        {verb}{sideName(s, contract?.ticker)} {tenths(limit)}</button>;
    })}
  </div>;
}

export type PhoneTab = 'desk' | 'positions' | 'orders';
/** Phone navigation between the desk and the dock's positions and orders. */
export function PhoneNav({ tab, onTab, positions, orders }: { tab: PhoneTab; onTab: (t: PhoneTab) => void; positions: number; orders: number }) {
  return <nav className="phone-nav" aria-label="Sections">
    {([['desk', 'Desk', 0], ['positions', 'Positions', positions], ['orders', 'Orders', orders]] as const).map(([id, label, n]) =>
      <button key={id} aria-pressed={tab === id} onClick={() => onTab(id)}>{label}{n ? <span className="count">{n}</span> : null}</button>)}
  </nav>;
}
